// @flow

export default function negate(predicate: (any) => boolean): (any) => boolean {
   return (e: any) => {
      return !predicate(e);
      // return !predicate.apply(null, args);
   };
}
